/* eslint-disable react/destructuring-assignment */
/* eslint-disable arrow-body-style */
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { t } from 'ttag';
import LockedSvg from '../../../sharedSvgs/LockedSvg';
import UnlockedSvg from '../../../sharedSvgs/UnlockedSvg';
import AddToFavorite from '../../../reusable-components/AddToFavorite/AddToFavorite';
import client from '../../../utils/client';
import * as actions from '../../appActions';

import './titleStyle.less';

// consider this solution to the pricematch
// https://css-tricks.com/css-content/
function ProductTitle(props) {
  const [myFavs, setMyFavs] = useState([]);

  useEffect(() => {
    const fetchFavs = async () => {
      const res = await client.get('/api/favorites/');
      setMyFavs(res.data.data);
    };
    fetchFavs();
  }, []);

  const {
    data: { title }
  } = props.app;

  const priceMatchText = props.app.priceMatch;

  const style = {
    color: 'white',
    textDecoration: 'underline'
  };

  const pricematch = (
    <a
      href={props.pricematchLink}
      style={style}
      target="_blank"
      key="pricematch"
      rel="noreferrer"
    >
      {t`price match`}
    </a>
  );

  const exclusiveIcon = () => {
    if (props.isMemberLocked) {
      return (
        <div>
          <LockedSvg />
        </div>
      );
    }

    if (!props.isMemberLocked && props.isExclusive) {
      return (
        <div>
          <UnlockedSvg />
        </div>
      );
    }
    return null;
  };

  return (
    <div
      id="productTitle"
      onMouseUp={() => props.PRICE_MATCH()}
      role="button"
      tabIndex="-1"
    >
      {priceMatchText.length > 0 &&
        props.app.data.offer_pricematch &&
        props.language !== 'en' && (
          <div className="priceMatch">
            <div className="priceMatchInner">
              <div className="closePriceMatch" />
              <div className="secondary-headline br">{t`We price match!`}</div>
              <div className="text">{props.supportLink}</div>
              <div className="text">{t`Have you found this product cheaper? Contact us to price match. Price match is not valid on Unisport Partner products.`}</div>
              <div className="text">
                {t`Read more`} {pricematch}
              </div>
            </div>
          </div>
        )}
      <div className="py-4 md:py-2">
        <div className="flex items-center gap-2">
          <AddToFavorite
            productId={props.app.data.product_id}
            favorites={myFavs}
          />
          {exclusiveIcon()}
        </div>
        <h1 className="m-0" id="pdp-title">
          {title}
        </h1>
      </div>
    </div>
  );
}
const mapStateToProps = ({ app, general }) => {
  return {
    app,
    pricematchLink: general.local_data.pricematchLink,
    supportLink: general.local_data.supportLink,
    language: general.language,
    isMemberLocked: app.data.is_member_locked,
    isExclusive: app.data.is_exclusive
  };
};
export default connect(mapStateToProps, actions)(ProductTitle);
